export const ADDPAYMENT_REQUEST = "ADDPAYMENT_REQUEST";
export const ADDPAYMENT_SUCCESS = "ADDPAYMENT_SUCCESS";
export const ADDPAYMENT_FAIL = "ADDPAYMENT_FAIL";
